import { useEffect, useState } from "react"
import PaymentFormByPnr from "../../../components/Payment-form-by-pnr"
import WithSidebar from "../../../layouts/WithSidebar"
import { ajax } from "../../../scripts/helper"
import utils from "../../../scripts/utils"
import { useSnackbar } from 'notistack'
import { useSearchParams, useLocation } from "react-router-dom"



const SingleLinkPNR = () => {

    const {state} = useLocation()
    const { enqueueSnackbar } = useSnackbar()

    const [data, setData] = useState()
    const [searchParams, setSearchParams] = useSearchParams()
    const id = searchParams.get("id")
    const [header, setHeader] = useState('Create Link')
    const [create, setCreate] = useState(false)



    // const getTransactiondetail = async (id) => {
        
    //     const res = await ajax({
    //         method: 'GET',
    //         url: utils.urls.linkDetail(id),
    //         hasToken: true,
    //         snackbar: enqueueSnackbar
    //     })

    //     if (!res) return

    //     console.log(res, 'dataaaaaaaaaa')

    //     setData(res.data)
    //     setCreate(false)
    // }



    
    useEffect ( () => {
        if(state){
            setData(state)
            setCreate(true)
        }if(id){
            // getTransactiondetail(id)
            setHeader('Edit Payment')
        }
        
    }, [])

    return(
        <WithSidebar pageTitle={'Create Link By PNR Detail'} breadcrumb={`Dashboard > Payment link > ${header} `}>
            <PaymentFormByPnr detail={data} create={create}/>
        </WithSidebar>
    )
}
export default SingleLinkPNR